module.exports = __webpack_public_path__ + "@/assets/img/koku-digi.16f4147d.jpeg";